import { Classes, Tooltip } from '@blueprintjs/core';
import styled from '@emotion/styled';
import React from 'react';
import { TLCode } from '../../../../common/enums';
import { DivSlimColumn, DivLine } from '../../styledComponents/StyledComponents';
import { TranslatedMessage } from '../../translation';

const DutyCountersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export interface SemesterDutyCountersProps {
  semesterNumber: number;
  dayDutiesCount?: number;
  dayNightDutiesCount?: number;
  nightDutiesCount?: number;
  BHDutiesCount?: number;
  saturdayDutiesCount?: number;
  sundayDutiesCount?: number;
}

export const SemesterDutyCounters = ({
  semesterNumber,
  dayDutiesCount,
  dayNightDutiesCount,
  nightDutiesCount,
  BHDutiesCount,
  saturdayDutiesCount,
  sundayDutiesCount,
}: SemesterDutyCountersProps) => {
  return (
    <DutyCountersContainer>
      <DivSlimColumn>
        <DivLine>
          <b>
            {'S' + semesterNumber}
            &nbsp;
            <Tooltip className={Classes.TOOLTIP_INDICATOR} content="Nbre total de gardes sur le semestre">
              <TranslatedMessage id={TLCode.Duties} />
            </Tooltip>
            &nbsp;
            {(dayDutiesCount === undefined ? 0 : dayDutiesCount) +
              (dayNightDutiesCount === undefined ? 0 : dayNightDutiesCount) +
              (nightDutiesCount === undefined ? 0 : nightDutiesCount)}
            {','}
            &nbsp;
            <Tooltip className={Classes.TOOLTIP_INDICATOR} content="Nbre total de gardes de jour seul sur le semestre">
              <TranslatedMessage id={TLCode.Days} />
            </Tooltip>
            &nbsp;
            {dayDutiesCount === undefined ? 0 : dayDutiesCount}
            {','}
            &nbsp;
            <Tooltip
              className={Classes.TOOLTIP_INDICATOR}
              content="Nbre total de gardes de nuit (avec/sans jour) sur le semestre"
            >
              <TranslatedMessage id={TLCode.Nights} />
            </Tooltip>
            &nbsp;
            {(dayNightDutiesCount === undefined ? 0 : dayNightDutiesCount) +
              (nightDutiesCount === undefined ? 0 : nightDutiesCount)}
            {','}
            &nbsp;
            <TranslatedMessage id={TLCode.MULTI_CALENDAR_TOOLBOX_BankHolidayShort} />
            &nbsp;
            {BHDutiesCount === undefined ? 0 : BHDutiesCount}
            {','}
            &nbsp;
            <TranslatedMessage id={TLCode.Saturday} />
            &nbsp;
            {saturdayDutiesCount === undefined ? 0 : saturdayDutiesCount}
            {','}
            &nbsp;
            <TranslatedMessage id={TLCode.Sunday} />
            &nbsp;
            {sundayDutiesCount === undefined ? 0 : sundayDutiesCount}
            &nbsp;
          </b>
        </DivLine>
      </DivSlimColumn>
    </DutyCountersContainer>
  );
};
